<template>
	<BaseCmsRotator :fetch="{code: 'benefits', limit: 4, response_fields: ['id','link','url_without_domain','title','title2']}" v-slot="{items}">
		<div v-if="items?.length" :class="['benefits', modeClass && modeClass]">
            <div class="wider-wrapper">
                <template v-for="(item,index) in items" :key="item.id">
                    <component :is="item.link ? NuxtLink : 'div'" :to="item.link ? item.url_without_domain : undefined" :class="['benefit', 'benefit-'+index]">
                        <div v-if="item.title" class="benefit-title">{{item.title}}</div>       
                        <div v-if="item.title2" class="benefit-content">
                            <template v-if="index == 0 && freeShippingAmount">{{item.title2.replace('%AMOUNT%', freeShippingAmount)}}</template>
                            <template v-else>{{item.title2}}</template>
                        </div>
                    </component>
                </template>
            </div>
		</div>
	</BaseCmsRotator>
</template>

<script setup>
    import { NuxtLink } from '#components';
    const props = defineProps(['modeClass']);

    const {getCartData} = useWebshop();
    const {formatCurrency} = useCurrency();
    const freeShippingAmount = computed(() => {
        const amount = getCartData()?.cart?.total_extra_shipping_to_free?.above;
        return amount ? formatCurrency(amount, {showCurrency: true}) : ' ';
    });

</script>

<style lang="less" scoped>
    .benefits{
        padding-bottom: 60px;
        .wider-wrapper{display: flex; justify-content: space-between;}
    }

    .hp-benefits{
        padding: 45px 0; content-visibility: auto; contain-intrinsic-size: 138px;
        .wider-wrapper{padding: 0 30px;}
    } 
    .benefit{
        position: relative; text-decoration: none;
        &:before{ position: absolute; display: block; color: var(--primaryColor); top: 1px; left: 0;}
    }
    .benefit-title{font-size: 22px; line-height: 28px; color: var(--primaryColor); font-weight: normal; }
    .benefit-content{font-size: 16px; line-height: 20px; font-weight: normal; color: var(--textColor);}

    .benefit-0{
        padding-left: 85px; 
        &:before{.icon-delivery; font: 36px/36px var(--fonti); top: 6px;}
    }
    .benefit-1{
        padding-left: 77px;
        &:before{.icon-flyers; font: 45px/45px var(--fonti);}
    }
    .benefit-2{
        padding-left: 63px;
        &:before{.icon-percentage; font: 38px/38px var(--fonti); border: 2px solid var(--primaryColor); border-radius: 50%; width: 42px; height: 42px;}
    }
    .benefit-3{padding-left: 68px;
        &:before{.icon-gift; font: 44px/44px var(--fonti); }
    }

    @media (max-width: @t){
        .benefits{padding-bottom: 42px;}
        .hp-benefits{padding: 25px 0;
            .wider-wrapper{padding: 0;}
        }
        .benefit-title{font-size: 18px; line-height: 22px; }
        .benefit-content{font-size: 13px; line-height: 17px;}

        .benefit-0{padding-left: 63px;
            &:before{font: 30px/30px var(--fonti); }
        }
        .benefit-1{padding-left: 58px;
            &:before{font: 38px/38px var(--fonti);}
        }
        .benefit-2{padding-left: 52px;
            &:before{font: 34px/34px var(--fonti); width:auto; height:auto;}
        }
        .benefit-3{padding-left: 54px;
            &:before{font: 37px/37px var(--fonti); top: 1px;}
        }        
    }
    @media (max-width: @tp){
        .benefits{padding-bottom: 35px;}
        .benefit-title{font-size: 16px; line-height: 21px;}
        .benefit-content{font-size: 12px; line-height: 16px;}

        .benefit-0{padding-left: 52px;
            &:before{font: 25px/25px var(--fonti);}
        }
        .benefit-1{padding-left: 44px;
            &:before{font: 32px/32px var(--fonti);}
        }
        .benefit-2{padding-left: 43px;
            &:before{font: 28px/28px var(--fonti); top: 2px;}
        }
        .benefit-3{padding-left: 43px; 
            &:before{font: 31px/31px var(--fonti); top: 2px;}
        }
        .hp-benefits{padding: 15px 0;}
    }
    @media (max-width: @m){
       .hp-benefits{padding-top: 25px;}
        .benefits{padding-bottom: 9px;
            .wider-wrapper{flex-wrap:wrap;}
        }
        .benefit{
            padding-left: 0px; margin-bottom: 18px;  width:50%; text-align: center;
            &:last-child{
                margin-bottom: 18px;
            }
            &:before{position: relative; max-height:38px; height:38px;}
        }
        .benefit-title{font-size: 16px; line-height:18px;}
        .benefit-content{font-size: 14px; line-height: 18px;}
        .benefit-0:before{font: 21px/21px var(--fonti);}
        .benefit-1:before{font: 26px/26px var(--fonti); left: 3px; top: 1px;}
        .benefit-2:before{font: 25px/25px var(--fonti); left: 0px; top: 4px; border: 1px solid var(--primaryColor); width: 26px; height: 26px; margin:auto auto 11px;}
        .benefit-3:before{font: 25px/25px var(--fonti); left: 4px; top: 4px;}        
    }
</style>